import { EMPTY_OBJECT } from '../../../constants/common'
import { DraftCreateActionSelect } from '../../Draft'
import { RequestCreateButton } from '../RequestCreateButton'

function RequestDraftCreateActionSelect({
  controlProps = EMPTY_OBJECT,
  ...props
}) {
  return (
    <DraftCreateActionSelect
      {...props}
      controlProps={{ Button: RequestCreateButton, ...controlProps }}
      createNewLabelKey='Request.CreateNewKey'
      openDraftLabelKey='Request.OpenDraftKey'
    />
  )
}

export default RequestDraftCreateActionSelect
